<template>
  <div class="page page-idcard-update input-page">
    <div class="title">
      <span>*</span>
      身份信息
    </div>
    <div class="take-photo">
      <div class="ul">
        <div class="li" @click="chooseImage('Z')">
          <div class="photo">
            <img class="img" v-if="form.imgIdCardUp" :src="form.imgIdCardUp" />
            <img class="img" v-else src="@/assets/home/img_people.png" />
          </div>
          <div class="phototext">身份证人像面</div>
        </div>
        <div class="li" @click="chooseImage('F')">
          <div class="photo">
            <img
              class="img"
              v-if="form.imgIdCardDown"
              :src="form.imgIdCardDown"
            />
            <img class="img" v-else src="@/assets/home/img_information.png" />
          </div>
          <div class="phototext">身份证国徽面</div>
        </div>
      </div>
    </div>
    <div class="section">
      <van-cell-group custom-class="input-content" :border="true">
        <van-field
          v-model="form.merName"
          clearable
          label="姓名"
          title-width="2.4rem"
          placeholder="姓名"
          placeholder-style="color: #ccc"
          disabled
        />
        <van-field
          v-model="form.merIdCode"
          clearable
          label="身份证号"
          title-width="2.4rem"
          placeholder="身份证号"
          placeholder-style="color: #ccc"
          disabled
        />
      </van-cell-group>
      <div class="range">
        <div class="titletxt">身份证有效期</div>
        <div class="range-date-picker">
          <div class="date" :class="form.manIdValidityStartDate ? '' : 'empty'">
            <span :class="'lightTheme'" v-if="form.manIdValidityStartDate">
              {{ form.manIdValidityStartDate }}
            </span>
            <span v-else>上传后自动识别</span>
          </div>
          <div class="to">至</div>
          <div class="date" :class="form.manIdValidityEndDate ? '' : 'empty'">
            <span :class="'lightTheme'" v-if="form.manIdValidityEndDate">
              {{ form.manIdValidityEndDate }}
            </span>
            <span v-else>上传后自动识别</span>
          </div>
        </div>
      </div>
    </div>

    <!-- 提交按钮 -->
    <div class="homecustom-btn">
      <van-button
        type="primary"
        :color="canSubmit ? '#FFA543' : '#FFCE98'"
        @click="onSubmit"
        block
      >
        提交
      </van-button>
    </div>

    <!-- 日期 -->
    <van-popup
      v-model="showCalendar"
      :zIndex="666"
      position="bottom"
      :close-on-click-overlay="false"
    >
      <van-datetime-picker
        type="date"
        :min-date="minDate"
        :max-date="maxDate"
        :value="currentDate"
        :formatter="formatter"
        @confirm="onCalendarConfirm"
        @cancel="showCalendar = false"
      />
    </van-popup>

    <van-toast id="van-toast" />
    <van-dialog confirm-button-color="#5280FE" id="van-dialog" />
  </div>
</template>

<script>
import moment from 'moment'
import { ocrAgentIdCard, updatePartnerImage } from '@/api/common'
import { chooseImage } from '@/common/oss'

export default {
  data() {
    return {
      signInfo: {},
      showText: '请上传',
      imgIdCardUpShow: '',
      imgIdCardDownShow: '',
      form: {
        imgIdCardUp: '', //身份证正面
        imgIdCardDown: '', //身份证背面
        merName: '', //商户姓名
        merIdCode: '', //身份证号
        manIdValidityStartDate: '', //身份证有效期开始
        manIdValidityEndDate: '' //身份证有效期结束
      },

      minDate: new Date(
        moment()
          .subtract(30, 'years')
          .format('YYYY-MM-DD')
      ),
      maxDate: new Date(
        moment()
          .add(30, 'years')
          .format('YYYY-MM-DD')
      ),
      userInfo: {},

      showCalendar: false, //显示日期选择框
      selectedDateType: '', //点击的是开始还是结束 3身份证有效期开始4身份证有效期结束  5 营业执照有效期开始 6 营业执照有效期结束
      selectedDate: {
        //选中的时间
        start: moment().format('YYYY.MM.DD'),
        end: moment().format('YYYY.MM.DD')
      },
      currentDate: new Date().getTime(),
      formatter(type, value) {
        if (type === 'year') {
          return `${value}年`
        }
        if (type === 'month') {
          return `${value}月`
        }
        return `${value}日`
      }
    }
  },
  computed: {
    canSubmit() {
      return (
        this.form.imgIdCardUp &&
        this.form.imgIdCardDown &&
        this.form.merName &&
        this.form.merIdCode &&
        this.form.manIdValidityStartDate &&
        this.form.manIdValidityEndDate
      )
    }
  },

  created() {},
  methods: {
    chooseImage(type) {
      chooseImage({
        count: 1,
        fileMaxSize: '',
        isNeedCompress: 1,
        sourceType: 2
      }).then(res => {
        if (type == 'Z') {
          this.form.imgIdCardUp = res[0] || ''
          this.getIdCardInfo('Z')
        }
        if (type == 'F') {
          this.form.imgIdCardDown = res[0] || ''
          this.getIdCardInfo('F')
        }
      })
    },
    // 上传身份证人像面
    afterRead(file) {
      file.status = 'uploading'
      file.message = '上传中...'
      uploadImg(file.file)
        .then(res => {
          console.log('上传身份证人像面', res)
          file.status = 'done'
          file.message = '上传成功'
          this.form.imgIdCardUp = res.originUrl
          this.imgIdCardUpShow = res.privateUrl
          this.getIdCardInfo('Z')
        })
        .catch(err => {
          file.status = 'failed'
          file.message = '上传失败'
        })
    },
    // 上传身份证国徽面
    afterBackRead(file) {
      file.status = 'uploading'
      file.message = '上传中...'
      uploadImg(file.file)
        .then(res => {
          console.log('国徽面', res)
          file.status = 'done'
          file.message = '上传成功'
          this.form.imgIdCardDown = res.originUrl
          this.imgIdCardDownShow = res.privateUrl
          this.getIdCardInfo('F')
        })
        .catch(err => {
          file.status = 'failed'
          file.message = '上传失败'
        })
    },
    getIdCardInfo(picType) {
      const params = {
        picType
      }
      if (picType == 'Z') {
        params.picUrl = this.form.imgIdCardUp
      }
      if (picType == 'F') {
        params.picUrl = this.form.imgIdCardDown
      }
      ocrAgentIdCard(params).then(res => {
        if (picType == 'Z') {
          // 进行信息回填
          this.form.merName = res.custName
          this.form.merIdCode = res.custCertNo
        }
        if (picType == 'F') {
          // 进行信息回填
          this.form.manIdValidityStartDate = moment(
            res.validitydate.split('-')[0]
          ).format('YYYY-MM-DD')

          if (res.validitydate.split('-')[1] == '长期') {
            this.form.manIdValidityEndDate = '长期'
          } else {
            this.form.manIdValidityEndDate = moment(
              res.validitydate.split('-')[1]
            ).format('YYYY-MM-DD')
          }
        }
      })
    },

    onShowCalendarClick(type) {
      this.showCalendar = true
      this.selectedDateType = type
    },
    // 选择日期
    onCalendarConfirm(e) {
      console.log(e)
      if (this.selectedDateType == 3) {
        if (
          e > moment(this.selectedDate.end).valueOf() &&
          this.selectedDate.end != moment(e).format('YYYY.MM.DD')
        ) {
          this.$toast('开始时间不能大于结束时间')
        } else {
          this.selectedDate.start = moment(e).format('YYYY.MM.DD')
          this.form.manIdValidityStartDate = this.selectedDate.start
        }
      } else if (this.selectedDateType == 4) {
        if (
          moment(this.selectedDate.start).valueOf() > e &&
          this.selectedDate.start != moment(e).format('YYYY.MM.DD')
        ) {
          this.$toast('开始时间不能大于结束时间')
        } else {
          this.selectedDate.end = moment(e).format('YYYY.MM.DD')
          this.form.manIdValidityEndDate = this.selectedDate.end
        }
      }
      if (this.selectedDateType == 5) {
        if (
          e > moment(this.selectedDate.end).valueOf() &&
          this.selectedDate.end != moment(e).format('YYYY.MM.DD')
        ) {
          this.$toast('开始时间不能大于结束时间')
        } else {
          this.selectedDate.start = moment(e).format('YYYY.MM.DD')
          this.form.licStartValidity = this.selectedDate.start
        }
      } else if (this.selectedDateType == 6) {
        if (
          moment(this.selectedDate.start).valueOf() > e &&
          this.selectedDate.start != moment(e).format('YYYY.MM.DD')
        ) {
          this.$toast('开始时间不能大于结束时间')
        } else {
          this.selectedDate.end = moment(e).format('YYYY.MM.DD')
          this.form.licEndValidity = this.selectedDate.end
        }
      }
      this.showCalendar = false
      console.log('this.selectedDate', this.selectedDate, this.form)
    },
    // 提交
    onSubmit() {
      // 身份证时间校验
      // if (this.form.legalValidity[1] == '长期') {
      //   this.form.legalValidity[1] = '2099-12-31'
      //   this.form.manIdValidityEndDate = '2099-12-31'
      // }

      // 商户个人信息
      if (!this.form.imgIdCardUp) {
        return this.$toast('请上传身份证正面')
      }
      if (!this.form.imgIdCardDown) {
        return this.$toast('请上传身份证背面')
      }
      let accountType = localStorage.getItem('accountType') || ''
      updatePartnerImage({
        ...this.form,
        accountType: accountType ? parseInt(accountType) : ''
      }).then(res => {
        this.$toast('提交成功')
        setTimeout(() => {
          SyHybridSdk.closeWebView({
            params: {},
            success: res => {}
          })
        }, 1000)
      })
    }
  }
}
</script>
